import React from "react";

import { GradientDefs } from "../../GradientDefs";

/**
 * @component CalendarAddXIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 * @prop {string} [gradient] - Optional CSS linear-gradient string to apply a custom fill.
 * Format: "linear-gradient(<angle>deg, <color1>, <color2>, ...)"
 *
 * @example
 * return (
 * <CalendarAddXIcon gradient="linear-gradient(135deg, #4da2ed, #f72222)" />
 * )
 *
 * @example
 * return (
 *   <CalendarAddXIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const CalendarAddXIcon = React.forwardRef(
  (
    {
      gradient,
      ...props
    }: React.SVGProps<SVGSVGElement> & {
      gradient?: string;
    },
    ref?: React.Ref<SVGSVGElement>
  ) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      data-testid="CalendarAddXIcon"
      fill={
        gradient
          ? "url(#icon-gradient)"
          : props?.fill
          ? props.fill
          : "var(--color-theme-600)"
      }
      focusable={false}
      ref={ref}
      {...props}
    >
      <GradientDefs gradient={gradient} />
      <path
        fillRule="evenodd"
        d="M7 2v2h10V2h2v2h1a2 2 0 0 1 2 2v6h-2V9H4v11h8v2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1V2zm12 12v3h3v2h-3v3h-2v-3h-3v-2l3-.001V14zm-9.586-3.828 1.414 1.414L9.414 13l1.414 1.414-1.414 1.414L8 14.414l-1.413 1.414-1.414-1.414L6.585 13l-1.413-1.413 1.414-1.414L8 11.586z"
      />
    </svg>
  )
);
CalendarAddXIcon.displayName = "CalendarAddXIcon";
export default CalendarAddXIcon;
